// vg-binding: P7.D-50
// vg-binding: P7.D-134
// vg-binding: P7.D-154
//
// apps/vendor/src/features/earnings/EarningsKpiCards.tsx

import { formatCents } from '@printway/shared/currency';

import { useTranslation } from '../../lib/i18n/index.js';
import type { WalletSummary } from '../wallet/api.js';

interface Props {
  summary: WalletSummary | undefined;
  isLoading?: boolean;
}

interface Card {
  label: string;
  value: number;
  testId: string;
}

function CardBox({ label, value, testId }: Card): JSX.Element {
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-pw-border bg-pw-bg p-5 shadow-sm"
    >
      <p className="text-sm text-pw-text-muted">{label}</p>
      <p className="mt-2 text-2xl font-semibold tracking-tight text-pw-text">
        {formatCents(value)}
      </p>
    </div>
  );
}

export function EarningsKpiCards({ summary, isLoading }: Props): JSX.Element {
  const { t } = useTranslation('wallet');
  if (isLoading || !summary) {
    return (
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_v, i) => (
          <div
            key={i}
            className="h-24 animate-pulse rounded-xl border border-pw-border bg-pw-surface"
          />
        ))}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
      <CardBox
        label={t('kpi.available')}
        value={summary.available_cents}
        testId="earnings-kpi-available"
      />
      <CardBox
        label={t('kpi.pending')}
        value={summary.pending_cents}
        testId="earnings-kpi-pending"
      />
      <CardBox
        label={t('kpi.paidOut')}
        value={summary.paid_out_cents}
        testId="earnings-kpi-paid-out"
      />
      <CardBox
        label={t('kpi.lifetime')}
        value={summary.lifetime_total_cents}
        testId="earnings-kpi-lifetime"
      />
    </div>
  );
}

export default EarningsKpiCards;
